import { render, staticRenderFns } from "./DisputeWithVoice.vue?vue&type=template&id=fffa4390&scoped=true"
import script from "./DisputeWithVoice.vue?vue&type=script&lang=js"
export * from "./DisputeWithVoice.vue?vue&type=script&lang=js"
import style0 from "./DisputeWithVoice.vue?vue&type=style&index=0&id=fffa4390&prod&lang=scss"
import style1 from "./DisputeWithVoice.vue?vue&type=style&index=1&id=fffa4390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffa4390",
  null
  
)

export default component.exports